import configData from '../../config.json';
import axios from 'axios';
import { Decrypt } from '../Helper';

export const GetEnrollUser = async (v) => {
    var config = {
        method: 'post',
        url: configData.API_ENDPOINT + `tempuser/get`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const GetUserById = async (id) => {
    var config = {
        method: 'get',
        url: configData.API_ENDPOINT + `users/${id}`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        // data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const uploadPdf = async (uploadUrl, pdfData) => {
    var config = {
        method: 'put',
        url: uploadUrl,
        headers: {
            'Content-Type': 'application/pdf',
        },
        data: pdfData
    };
    return axios(config)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error;
        });
}

export const UpdateEnrollUser = async (id,v) => {
    var config = {
        method: 'GET',
        url: configData.API_ENDPOINT + `tempuser/${id}`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const CreateEnrollUser = async (v) => {
    var config = {
        method: 'POST',
        url: configData.API_ENDPOINT + `tempuser`,
        headers: {
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const UpdatEnrolledeUser = async (id,v) => {
    var config = {
        method: 'PUT',
        url: configData.API_ENDPOINT + `tempuser/${id}`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const handleDownload = async (fileName) => {
    var config = {
      method: 'GET',
      url: configData.API_ENDPOINT + `tempuser/download/${fileName}`,
      headers: {
        Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
        'Content-Type': 'application/json',
    },
};
return axios(config)
.then(response => {
    const url = response.data.data;
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
})
.catch(error => {
    // Handle download error
});
}

export const GetRole = async (v) => {
    var config = {
        method: 'post',
        url: configData.API_ENDPOINT + `roles/get`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}
export const DeleteUser = async (id) => {
    var config = {
        method: 'delete',
        url: configData.API_ENDPOINT + `users/${id}`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        // data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}     

export const GetOTP = async (id) => {
    var config = {
        method: 'GET',
        url: configData.API_ENDPOINT + `tempuser/otp/${id}`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        // data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const ApproveTempUser = async (id) => {
    var config = {
        method: 'PUT',
        url: configData.API_ENDPOINT + `tempuser/approve/${id}`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        // data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}